import { takeLatest, put, call } from 'redux-saga/effects'
import { login } from '../../../../utils/User/axios'
import { ROUTE } from '../../../../utils/User/constants/routingConfig/routeDetails'
import { loginRequest, loginRequestSuccess, loginRequestFailed } from '../Reducer'

export default function* loginWatcherSaga() {
  yield takeLatest(loginRequest.type, loginSaga)
}

function* loginSaga({ payload }) {
  try {
    const { history, contact, password } = payload
    const response = yield call(login, { username: contact, password })
    yield localStorage.setItem('user', JSON.stringify(response.data.user))
    yield localStorage.setItem('jwtToken', response.data.accessToken)
    yield put(loginRequestSuccess(response.data.user))
    history.push(ROUTE.HOME)
  } catch (error) {
    yield put(loginRequestFailed(error))
  }
}
